import { Stack, Skeleton } from "@mui/material";

export const CardChallengeSkeleton = () => (
  <Stack
    px={3}
    pt={4}
    pb={6}
    mb={2}
    gap={4}
    borderRadius={2}
    alignItems="center"
    justifyContent="space-between"
    boxShadow="0px 1px 5px 0px rgba(0, 0, 0, 0.20)"
    bgcolor="common.white"
    position="relative"
    height="100%"
  >
    <Stack gap={2} alignItems="center" width="100%">
      <Skeleton variant="circular" width={48} height={48} />
      <Skeleton variant="text" width="70%" height={24} />
    </Stack>
    <Skeleton variant="text" width="90%" height={16} />
    <Skeleton variant="text" width={60} height={20} />
    <Skeleton variant="rounded" width="100%" height={8} />
  </Stack>
);
